import { Component, OnInit, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AlertController } from '@ionic/angular';
import { PACKAGE_TYPE } from 'src/app/constants';
export interface IRouteObjectDTO {
  name: string;
  width: number; // cm
  height: number; // cm
  length: number; // cm
  weight: number; // kg
  packageType?: PACKAGE_TYPE
}

@Component({
  selector: 'app-send-objects',
  templateUrl: './send-objects.page.html',
  styleUrls: ['./send-objects.page.scss']
})
export class SendObjectsPage implements OnInit {
  @Input() index: number = 0;
  @Input() objects: IRouteObjectDTO[] = [];
  @Input() objectToEdit: IRouteObjectDTO;
  @Input() editIndex: number = -1;

  objectForm: FormGroup;
  editingIndex: number = -1;
  isEditing: boolean = false;
  packageTypes = Object.keys(PACKAGE_TYPE); // Aggiunto per la selezione del tipo di pacco

  constructor(
    private modalController: ModalController,
    private formBuilder: FormBuilder,
    private alertController: AlertController
  ) {
    this.objectForm = this.formBuilder.group({
      name: [, Validators.required],
      width: [''],
      height: [''],
      length: [''],
      weight: [''],
      packageType: [''] // Aggiunto per il tipo di pacco
    });
  }

  ngOnInit() {
    // Gli oggetti vengono passati tramite @Input
    if (!this.objects) {
      this.objects = [];
    }
    
    // Se è stato passato un oggetto da modificare, impostalo nel form
    if (this.objectToEdit) {
      this.loadObjectToEdit();
    } else {
      const index = this.index || 0;
      this.objectForm.patchValue({
        name: `Pacco ${index + 1}`
      });
    }
  }

  loadObjectToEdit() {
    this.objectForm.patchValue({
      name: this.objectToEdit.name || '',
      width: this.objectToEdit.width || '',
      height: this.objectToEdit.height || '',
      length: this.objectToEdit.length || '',
      weight: this.objectToEdit.weight || '',
      packageType: this.objectToEdit.packageType || '' // Carica il tipo di pacco
    });
    this.editingIndex = this.editIndex;
    this.isEditing = this.editIndex >= 0;
  }

  addObject() {
    if (this.objectForm.valid) {
      const formValue = this.objectForm.value;
      const newObject: IRouteObjectDTO = {
        name: formValue.name,
        width: formValue.width ? parseFloat(formValue.width) : 0,
        height: formValue.height ? parseFloat(formValue.height) : 0,
        length: formValue.length ? parseFloat(formValue.length) : 0,
        weight: formValue.weight ? parseFloat(formValue.weight) : 0,
        packageType: formValue.packageType // Aggiunto per il tipo di pacco
      };

      if (this.isEditing && this.editingIndex >= 0) {
        this.objects[this.editingIndex] = newObject;
      } else {
        this.objects.push(newObject);
      }

      this.objectForm.reset();

      this.saveAndReturn();
    }
  }

  editObject(index: number) {
    const obj = this.objects[index];
    this.objectForm.patchValue({
      name: obj.name || '',
      width: obj.width || '',
      height: obj.height || '',
      length: obj.length || '',
      weight: obj.weight || '',
      packageType: obj.packageType || '' // Aggiunto per il tipo di pacco
    });
    this.editingIndex = index;
    this.isEditing = true;
  }

  cancelEdit() {
    this.objectForm.reset();
    this.editingIndex = -1;
    this.isEditing = false;
  }

  async confirmRemoveObject(index: number) {
    const objectName = this.objects[index].name || 'questo oggetto';
    
    const alert = await this.alertController.create({
      header: 'Conferma rimozione',
      message: `Sei sicuro di voler rimuovere "${objectName}"?`,
      buttons: [
        {
          text: 'Annulla',
          role: 'cancel',
          cssClass: 'secondary'
        },
        {
          text: 'Rimuovi',
          cssClass: 'danger',
          handler: () => {
            this.removeObject(index);
          }
        }
      ]
    });

    await alert.present();
  }

  removeObject(index: number) {
    this.objects.splice(index, 1);
    if (this.isEditing && this.editingIndex === index) {
      this.cancelEdit();
    }
  }

  async saveAndReturn() {
    console.log("Return with objects:", this.objects);
    await this.modalController.dismiss({
      objects: this.objects
    });
  }

  async cancel() {
    await this.modalController.dismiss();
  }
}